<template>
  <div>
    <b-card no-body class="card-profile" img-src=https://picsum.photos/600/300>    
      <b-row class="justify-content-center">
        <b-col lg="3" class="order-lg-2">
          <div class="card-profile-image">
            <a href="#">
              <b-img v-if="user.photoURL" :src="user.photoURL" rounded="circle" />
              <b-img v-else src="https://picsum.photos/300" rounded="circle" />            
            </a>
          </div>
        </b-col>
      </b-row>

      <b-card-header class="text-center border-0 pt-7 pb-0">
        <h5 class="h3">
          {{ user.name }}
        </h5>
        <div class="h5 font-weight-300">
          {{ getUserType }}
        </div>
        <!-- <div class="d-flex justify-content-between">
          <a href="#" class="btn btn-sm btn-info mr-4">Connect</a>
          <a href="#" class="btn btn-sm btn-default float-right">Message</a>
        </div> -->
      </b-card-header>

      <b-card-body class="pt-0">
        <div class="d-flex justify-content-center mt-2">
          <b-button size="sm" @click="showModal=!showModal">Cambiar foto de perfil </b-button>
        </div>

        <!-- <b-row>
          <b-col >
            <div class="card-profile-stats d-flex justify-content-center">
              <div>
                <span class="heading">10/05/2012</span>
                <span class="description">Usuaria Desde</span>
              </div>
            </div>
          </b-col>
        </b-row> -->
        <!-- <div class="text-center">
          <h5 class="h3">
            Jessica Jones<span class="font-weight-light">, 27</span>
          </h5>
          <div class="h5 font-weight-300">
            <i class="ni location_pin mr-2"></i>Bucharest, Romania
          </div>
          <div class="h5 mt-4">
            <i class="ni business_briefcase-24 mr-2"></i>Solution Manager - Creative Tim Officer
          </div>
          <div>
            <i class="ni education_hat mr-2"></i>University of Computer Science
          </div>
        </div> -->
      </b-card-body>
    </b-card>
      
    <!-- Change profile picture modal -->
    <b-modal v-model="showModal" :footer-class="'profile-image-modal-footer'" hide-header centered>

      <b-form-file accept="image/*" size="sm" placeholder="Elige un archivo..." browse-text="Buscar" v-model="image"></b-form-file>
      <small>Para mejores resultados, elige una imagen cuadrada.</small>
      <template slot="modal-footer">
        <base-button type="primary" size="sm" @click="changePicture">Aceptar</base-button>
        <base-button type="secondary" @click="showModal = false" size="sm">Cerrar</base-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/storage' 
import Compress from 'compress.js'

export default {
  props: ["user"],
  data() {
    return {
      showModal: false,
      image: null,
      placeholderAvatarURL: null
    }
  },
  methods: {
    async changePicture() {
      this.showModal = false
      const photoURL = await this.uploadPicture()
      this.$emit('updatePicture', photoURL)
    },
    async uploadPicture() {
      if (this.image) {

        try {
          // Resize the image
          const resizedAvatar = await this.resizePicture(this.image)

          // Set reference to the firebase storage
          const storageRef = firebase.storage().ref('avatars/' + this.user.id)

          // Upload the image and get the download URL
          var res = await storageRef.put(resizedAvatar)
          const imgURL = await res.ref.getDownloadURL()

          return imgURL

        } catch (err) {
          console.log(err)
          // Return a placeholder image if the upload didn't complete
          return this.placeholderAvatarURL
        }

      } else {
        // Put a placeholder image if no avatar was set
        return this.placeholderAvatarURL
      }
    },
    async resizePicture(file) {

      const compress = new Compress()

      const results = await compress.compress([file], {
        size: 0.02,
        maxWidth: 300,
        resize: true
      })

      const image = results[0].data
      const imgExt = results[0].ext

      return Compress.convertBase64ToFile(image, imgExt)

    }
  },
  computed: {
    getUserType() {
      if (this.user.userType === "user") {
        return 'Usuaria'
      }
      else if (this.user.userType === "coach") {
        return 'Coach'
      }
      else if (this.user.userType === "admin") {
        return 'Admin'
      }
    }
  }
}
</script>

<style>
.profile-image-modal-footer {
  padding-top: 0;
  display: flex;
  justify-content: center;
}
</style>